import React from 'react';
import DragHandle from './DragHandle';
import {
  getMilestoneLayoutDims,
  getMilestoneLabelSide,
  getMilestoneAnchor,
  getMilestoneLabelRect,
} from '../../../utils/milestoneUtils';

/**
 * Grip at the top-left of a visible node (or on a milestone's label).
 * Hidden while a node is being dragged.
 */
export default function DragHandlesGroup({
  containerRef,
  isDragging,
  tasks,
  nodePositions,
  nodeDimensions,
  canvasToScreen,
  onMouseDown,
  menuOnly = false,
}) {
  return (
    <div ref={containerRef} className="handles-layer__drag-handles" style={{ display: isDragging ? 'none' : undefined }}>
      {tasks.map((task) => {
        const pos = nodePositions[task.id];
        if (!pos) return null;

        let screenPos;
        if (task.nodeType === 'milestone') {
          const dims = getMilestoneLayoutDims(nodeDimensions, task.id);
          const anchor = getMilestoneAnchor(task);
          const hostPos = anchor ? nodePositions[anchor.hostTaskId] : null;
          const hostDims = anchor ? nodeDimensions[anchor.hostTaskId] : null;
          const side = getMilestoneLabelSide(pos, dims, hostPos, hostDims);
          const labelRect = getMilestoneLabelRect(pos, dims, side);
          screenPos = canvasToScreen(labelRect.x - 8, labelRect.y + 8);
        } else {
          screenPos = canvasToScreen(pos.x - 8, pos.y + 8);
        }

        return (
          <DragHandle
            key={`drag-${task.id}`}
            task={task}
            screenPos={screenPos}
            menuOnly={menuOnly}
            onMouseDown={(e) => onMouseDown(task, e)}
          />
        );
      })}
    </div>
  );
}
